import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class HandsetService {
  public handsetChanges: Observable<boolean>;
  public xsChanges: Observable<boolean>;
  public smChanges: Observable<boolean>;
  public mobileChanges: Observable<boolean>;
  public isHandset: boolean;
  public isXs: boolean;
  public isSmall: boolean;

  constructor(private breakpointObserver: BreakpointObserver) {
    this.handsetChanges = this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium])
      .pipe(map((state) => state.matches));
    this.xsChanges = this.breakpointObserver.observe([Breakpoints.XSmall]).pipe(map((state) => state.matches));
    this.smChanges = this.breakpointObserver.observe([Breakpoints.Small]).pipe(map((state) => state.matches));
    this.mobileChanges = this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).pipe(map((state) => state.matches));

    this.handsetChanges.subscribe((state) => (this.isHandset = state));
    this.xsChanges.subscribe((state) => (this.isXs = state));
    this.smChanges.subscribe((state) => (this.isSmall = state));
  }

  public get isNotMobile() {
    return !this.isXs && !this.isSmall;
  }

  public get isMobile() {
    return this.isXs || this.isSmall;
  }

}
